export default "/images/vendor/flag-icons/flags/4x3/pw.svg?f9ea0367acd37580acec76f4745b3161";